import React from 'react';

interface RegistrationTabsProps {
    activeTab: string;
    onTabChange: (tab: string) => void;
}

export const RegistrationTabs: React.FC<RegistrationTabsProps> = ({ activeTab, onTabChange }) => {
    const tabs = [
        { id: 'new', label: 'New Requests' },
        { id: 'under_review', label: 'Under Review' },
        { id: 'setup_pending', label: 'Setup Pending' },
        { id: 'existing', label: 'Active Temples' },
        { id: 'rejected', label: 'Rejected' }
    ];

    return (
        <div className="border-b border-gray-200 mb-8 overflow-x-auto scrollbar-hide">
            <style>{`.scrollbar-hide::-webkit-scrollbar { display: none; }`}</style>
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`${activeTab === tab.id
                            ? 'border-orange-500 text-orange-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200`}
                    >
                        {tab.label}
                    </button>
                ))}
            </nav>
        </div>
    );
};
